module.exports = __webpack_public_path__ + "kudos_19.svg?dfe5ccff1c49f554848c28b7e6284199";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_19.svg
// module id = 116
// module chunks = 0